import t from 'vivino-js/translationString';
import { Certification } from 'vivino-ui/icons/WineFacts';

const CERTIFICATION_KEYS = ['certified_organic', 'certified_biodynamic'];

const TRANSLATION_PATH = 'components.shared.wine_summary';
const TRANSLATIONS = {
  certification: `${TRANSLATION_PATH}.certification`,
  certified_organic: `${TRANSLATION_PATH}.certified_organic`,
  certified_biodynamic: `${TRANSLATION_PATH}.certified_biodynamic`,
};

export const getCertificationFact = (vintage, translationFunc = t) => {
  const wineFacts = vintage?.wine_facts || {};
  const values = CERTIFICATION_KEYS.reduce((memo, key) => {
    if (wineFacts[key]) {
      memo.push({
        name: t(TRANSLATIONS[key]),
      });
    }
    return memo;
  }, []);
  if (values.length === 0) {
    return null;
  }
  return {
    key: 'certification',
    headerLabel: translationFunc(TRANSLATIONS.certification),
    icon: Certification,
    values,
  };
};
